(() => {
  const TIER_SECTION = "[data-gdp-pdp-buy].has-tiers";

  const readLines = input => (input.dataset.tierLines || "")
    .split(",")
    .map(entry => entry.split(":"))
    .filter(parts => /^\d+$/.test((parts[0] || "").trim()))
    .map(parts => ({ id: parts[0].trim(), quantity: Math.max(1, Number(parts[1]) || 1) }));

  const applyTier = input => {
    const form = input.form || input.closest("form");
    if (!form) return;
    const idField = form.querySelector("[data-gdp-tier-id]");
    const quantityField = form.querySelector("[data-gdp-tier-qty]");
    const extra = form.querySelector("[data-gdp-tier-extra]");
    if (!idField || !quantityField || !extra) return;

    const lines = readLines(input);
    // disabled may be a temporary submit lock; catalog availability is explicit.
    if (!lines.length || input.dataset.available !== "true") {
      idField.disabled = true; quantityField.disabled = true;
      while (extra.firstChild) extra.removeChild(extra.firstChild);
      return;
    }

    while (extra.firstChild) extra.removeChild(extra.firstChild);

    if (lines.length === 1) {
      idField.disabled = false;
      quantityField.disabled = false;
      idField.value = lines[0].id;
      quantityField.value = String(lines[0].quantity);
      return;
    }

    // Plusieurs lignes : le panier natif accepte items[n][id] / items[n][quantity].
    idField.disabled = true;
    quantityField.disabled = true;
    lines.forEach((line, index) => {
      const idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = `items[${index}][id]`;
      idInput.value = line.id;
      const quantityInput = document.createElement("input");
      quantityInput.type = "hidden";
      quantityInput.name = `items[${index}][quantity]`;
      quantityInput.value = String(line.quantity);
      extra.appendChild(idInput);
      extra.appendChild(quantityInput);
    });
  };

  const sync = (scope = document) => {
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(TIER_SECTION).forEach(section => {
      const inputs = Array.from(section.querySelectorAll("input[data-tier-lines]"));
      if (!section.dataset.gdpTierInitialized) {
        section.dataset.gdpTierInitialized = "true";
        const requested = new URL(window.location.href).searchParams.get("variant");
        if (requested) {
          const match = inputs.find(input => input.dataset.variantId === requested);
          inputs.forEach(input => { input.checked = input === match; });
        }
      }
      const selected = inputs.find(input => input.checked);
      const notice = section.querySelector("[data-gdp-tier-unavailable]");
      if (notice) notice.hidden = !!selected;
      if (selected) {
        applyTier(selected);
        selected.dispatchEvent(new Event("gdp:tier-sync", { bubbles: true }));
      } else {
        const form = section.querySelector("form");
        form?.querySelectorAll('[data-gdp-tier-id], [data-gdp-tier-qty]').forEach(field => { field.disabled = true; });
        const extra = form?.querySelector('[data-gdp-tier-extra]');
        if (extra) extra.replaceChildren();
        section.dispatchEvent(new Event("gdp:tier-unselected", { bubbles: true }));
      }
    });
  };

  const onChange = event => {
    const input = event.target;
    if (!input || input.tagName !== "INPUT" || !input.dataset.tierLines) return;
    if (!input.checked || !input.closest(TIER_SECTION)) return;
    applyTier(input);
    const notice = input.closest(TIER_SECTION)?.querySelector("[data-gdp-tier-unavailable]");
    if (notice) notice.hidden = true;
    try {
      const url = new URL(window.location.href); url.searchParams.set("variant", input.dataset.variantId);
      window.history.replaceState(window.history.state, "", url.href);
    } catch (_) {}
  };

  if (!window.GDPTiers) {
    window.GDPTiers = { sync };
    document.addEventListener("change", onChange);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => sync(document), { once: true });
    } else {
      sync(document);
    }
    window.addEventListener("pageshow", () => sync(document));
    document.addEventListener("shopify:section:load", event => sync(event.target));
  } else {
    window.GDPTiers.sync(document);
  }
})();
